export enum PusherEventName {
  REFETCH = 'refetch'
}
